/**
 * Created by Victor Rojo on 6/11/19.
 */
import { Component, TemplateRef, ViewChild}     from '@angular/core';

import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { BsDatepickerConfig, BsLocaleService } from 'ngx-bootstrap/datepicker';

import { Subject }            from 'rxjs';

import {TankDeliveryNote} from "./TankDeliveryNote";
import {I18NService} from "../../shared/i18n/i18n.service";
import {IPlaceValuelistService} from "../../iPlace/iPlace-valuelist.service";
import {TankDeliveryNoteService} from "./TankDeliveryNote.service";
import {TankService} from "../ipetrol/Tank.service";
import {TankDeliveryNoteLine} from "./TankDeliveryNote";

@Component({
  templateUrl: './TankDeliveryNote.component.html',
  styleUrls: ['./TankDeliveryNote.component.css']
})
export class TankDeliveryNoteComponent {
  rows: TankDeliveryNote[] = [];
  tankDeliveryNotes: TankDeliveryNote[] = [];
  isLoading = false;
  tableMessages: any;
  dropdownList:any = [];
  selectedItems:any = [];
  dropdownSettings:any = {};
  formDropdownSettings:any = {};
  advancedSearch:boolean = false;
  dateRangeFilter:any;
  bsConfig: Partial<BsDatepickerConfig>;
  tankDeliveryNote: TankDeliveryNote;
  @ViewChild('detailTemplate', { static: true })
  private detailTempRef : TemplateRef<any>;
  @ViewChild('createTemplate', { static: true })
  private createTempRef : TemplateRef<any>;
  @ViewChild('confirmTemplate', { static: true })
  private confirmTemplateRef : TemplateRef<any>;
  @ViewChild('errorTemplate', { static: true })
  private errorTemplate : TemplateRef<any>;
  private flagCreate = false;
  modalRef: BsModalRef;
  confirmModalRef: BsModalRef;
  errorModalRef: BsModalRef;
  selectedIPlaceId:any = [];
  isLoadingProductTank = false;
  isCreatingProductTank = false;
  formInvalid = false;
  private searchTerms = new Subject<string>();
  private searchText= '';


  constructor(
    private i18nService: I18NService,
    private modalService: BsModalService,
    private iPlaceValuelistService: IPlaceValuelistService,
    private tankDeliveryNoteService: TankDeliveryNoteService,
    private tankService: TankService
  ) {


    this.tableMessages = {};
    this.tableMessages.emptyMessage = this.i18nService.get("noDataToDisplay");
    this.tableMessages.totalMessage = this.i18nService.get("total");
    this.tableMessages.selectedMessage = this.i18nService.get("selected");


    if ( (<any>Object).values(this.iPlaceValuelistService.getValuelist()).length ) {
      this.dropdownList = (<any>Object).values(this.iPlaceValuelistService.getValuelist())
        .sort((a:any,b:any) => a.iPlaceName.localeCompare(b.iPlaceName));
    } else {
      this.iPlaceValuelistService.reload()
        .then( () => this.dropdownList = (<any>Object).values(this.iPlaceValuelistService.getValuelist())
          .sort((a:any,b:any) => a.iPlaceName.localeCompare(b.iPlaceName)))
    }

    this.dropdownSettings = {
      singleSelection: false,
      primaryKey: 'idiPlace',
      labelKey: 'iPlaceName',
      selectAllText: i18nService.get("selectAll"),
      unSelectAllText: i18nService.get("unselectAll"),
      filterSelectAllText: i18nService.get("selectAllFiltered"),
      filterUnSelectAllText: i18nService.get("unselectAllFiltered"),
      noDataLabel: i18nService.get("noResults"),
      text: i18nService.get("selectStation"),
      searchPlaceholderText: i18nService.get("search"),
      badgeShowLimit: 2,
      enableSearchFilter: true,
      classes: "form-angular2-multiselect"
    };

    this.formDropdownSettings = {
      singleSelection: true,
      enableCheckAll: false,
      primaryKey: 'idiPlace',
      labelKey: 'iPlaceName',
      selectAllText: i18nService.get("selectAll"),
      unSelectAllText: i18nService.get("unselectAll"),
      filterSelectAllText: i18nService.get("selectAllFiltered"),
      filterUnSelectAllText: i18nService.get("unselectAllFiltered"),
      noDataLabel: i18nService.get("noResults"),
      text: i18nService.get("selectStation"),
      searchPlaceholderText: i18nService.get("search"),
      enableSearchFilter: true,
      classes: "form-angular2-multiselect iplace-select"
    };

    this.bsConfig = Object.assign({}, {containerClass: "theme-custom", showWeekNumbers: false});

    let startDate = new Date();
    startDate.setHours(0,0,0,0);
    let endDate = new Date();
    endDate.setHours(0,0,0,0);
    endDate = new Date(endDate.getTime() - 604800000);
    this.dateRangeFilter = [endDate, startDate];

    this.reloadTankDeliveryNotes();
  }

  reloadTankDeliveryNotes(){
    this.isLoading = true;
    let iPlaceIds = this.selectedItems.map(iplace => iplace.idiPlace)
      .join(";");
    let start = this.dateRangeFilter[0].getTime();
    let end = this.dateRangeFilter[1].getTime() + 86400000;
    this.tankDeliveryNoteService.get(iPlaceIds, start, end)
      .then( list => {
        this.tankDeliveryNotes = list;
        this.filter();
        this.isLoading = false;
      })
      .catch( error => {
        this.isLoading = false;
      });
  }

  filter(){
    let deliveries = [];
    if ( this.searchText ) {
      deliveries = this.tankDeliveryNotes.filter((tankDeliveryNote:any) => tankDeliveryNote.deliveryNoteId.toUpperCase().indexOf(this.searchText) >= 0);
    } else {
      deliveries = this.tankDeliveryNotes;
    }
    this.rows = deliveries;
  }

  createTankDeliveryNote(){
    this.flagCreate = true;
    let date =  new Date();
    this.tankDeliveryNote = new TankDeliveryNote(null, null, date, date, null, null, null, []);
    this.selectedIPlaceId = [];
    this.enterEditState();
    this.modalRef = this.modalService.show(this.createTempRef);
  }

  onActivate(event: any) {
    if ( event.type == 'click' && event.column.prop) {
      this.tankDeliveryNote = event.row;
      this.tankDeliveryNote.lines.forEach(line => {
        line.tankName = this.i18nService.get('tank') + " " + line.localTankId + ( line.productId ? " - " + this.i18nService.get(line.productId) : (line.productName ? " - " + line.productName : "") );
      });
      this.flagCreate = false;
      this.formInvalid = false;
      this.modalRef = this.modalService.show(this.detailTempRef);
      //let promise = this.loadNotification(event.row.id);
      //promise.catch( (error:any) => {
      //  this.modalService.hide(1);
      //});
    }
  }

  onItemSelect(item: any) {
    this.reloadTankDeliveryNotes();
  }

  onSelectAll(item: any){
    this.reloadTankDeliveryNotes();
  }

  onTankDeliveryNoteItemSelect(item: any) {
    let i = 0;
    this.tankDeliveryNote.iPlaceId = item.idiPlace;
    this.isLoadingProductTank = true;
    this.tankDeliveryNote.lines = [];
    this.tankService.getProductTanks(item.idiPlace)
      .then( list => {
        let lines = [];
        this.isLoadingProductTank = false;
        list.forEach((tank:any) => {
          let tankName = this.i18nService.get('tank') + " " + tank.localTankId + ( tank.productId ? " - " + this.i18nService.get(tank.productId) : (tank.productName ? " - " + tank.productName : "") );
          lines.push(new TankDeliveryNoteLine(tank.tankId, tank.localTankId, tankName, tank.productName, tank.productId,null, null, null));
        });
        this.tankDeliveryNote.lines = lines.sort((a:any,b:any) => a.localTankId - b.localTankId);
      })
      .catch( error => {

      });
  }

  onTankDeliveryNoteItemDeselect(item: any) {
    let i = 0;
    this.tankDeliveryNote.iPlaceId = null;
    this.tankDeliveryNote.lines = [];
  }

  hide() {
    this.modalService.hide(1);
    this.flagCreate = false;
    this.tankDeliveryNote = null;
    this.formInvalid = false;
  }

  hideConfirm(){

  }

  confirmCreate(){
    this.isCreatingProductTank = true;
    this.tankDeliveryNoteService.create(this.confirmModalRef.content.tankDeliveryNote)
      .then( list => {
        this.hide();
        this.isCreatingProductTank = false;
        this.reloadTankDeliveryNotes()
      })
      .catch( error => {
        this.confirmModalRef.hide();
        this.isCreatingProductTank = false;
        if ( error.code && error.code == 1280 ) {
          this.errorModalRef = this.modalService.show(this.errorTemplate, { class: 'confirm-create' });
        }
      });
  }

  registerTankDeliveryNote(){
    let tankDeliveryNote = Object.assign({}, this.tankDeliveryNote);
    tankDeliveryNote.lines = tankDeliveryNote.lines
      .filter( line => (line.volume && line.volume > 0) || line.temperature );
    this.checkValidData(tankDeliveryNote);
    if ( !this.formInvalid ) {
      this.confirmModalRef = this.modalService.show(this.confirmTemplateRef, { class: 'confirm-create' });
      this.confirmModalRef.content = {
        tankDeliveryNote: tankDeliveryNote
      };
    }
  }

  private checkValidData(tankDeliveryNote){
    this.formInvalid = !(tankDeliveryNote.iPlaceId
      && tankDeliveryNote.deliveryNoteId
      && tankDeliveryNote.startDate
      && tankDeliveryNote.endDate
      && tankDeliveryNote.lines.length
      && !tankDeliveryNote.lines
        .filter(line => !line.volume || !line.temperature)
        .length)
  }

  enterReadState() {
  }

  enterEditState(){

  }

  onDateRangeChange(any:any){
    this.reloadTankDeliveryNotes();
  }
}
